/**
 * @generated SignedSource<<cd2e9dccf5977685fce24709559a52b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespShippingReturns_item$data = {
  readonly isDepositAvailable: boolean;
  readonly isListingMigrated: boolean | null;
  readonly returnPolicy: {
    readonly buyerCopy: {
      readonly returnPolicySectionHeader: {
        readonly htmlCopy: string | null;
      } | null;
    } | null;
  } | null;
  readonly seller: {
    readonly isAccessible: boolean | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespPricingGuidance_item" | "PdpSharedBuyerProtectionBox_item" | "PdpSharedDepositPaymentDetail_item" | "PdpSharedDetailReturnPolicy_item" | "PdpSharedDetailShipping_item">;
  readonly " $fragmentType": "PdpRespShippingReturns_item";
};
export type PdpRespShippingReturns_item$key = {
  readonly " $data"?: PdpRespShippingReturns_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespShippingReturns_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespShippingReturns_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailReturnPolicy_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDepositPaymentDetail_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyerProtectionBox_item"
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespPricingGuidance_item"
        }
      ]
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        }
      ],
      "kind": "ScalarField",
      "name": "isDepositAvailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "ReturnPolicy",
      "kind": "LinkedField",
      "name": "returnPolicy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ReturnPolicyCopy",
          "kind": "LinkedField",
          "name": "buyerCopy",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "InlineCtaCopy",
              "kind": "LinkedField",
              "name": "returnPolicySectionHeader",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "htmlCopy",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isListingMigrated",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "d99230cb65977d82dc98fac6ae6fced3";

export default node;
